/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { localiteParenteSchema } from "./localiteParenteSchema.ts";
import { z } from "zod";

export const localiteSchema = z.object({
      "nom": z.string().describe("Nom de la commune"),
  "codePostal": z.string().describe("Code postal de la commune"),
  "type": z.string().describe("Type de localité tel que porté par le datalake (`localite_type`). Valeurs connues :\n`commune`, `commune_ancienne`, `commune_deleguee`, `quartier`. Chaîne libre, pas un enum :\nune valeur nouvelle côté datalake ne doit pas faire échouer la recherche.\n").optional(),
  "parent": z.lazy(() => localiteParenteSchema).describe("Localité de rattachement d'une localité (`localite_parent_id`), un seul niveau. Portée aussi\npar les codes postaux secondaires d'une même commune : seul `Localite.type` permet de\nreconnaître une ancienne commune ou une commune déléguée.\n").optional()
      })